var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyExamIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0_1623_3977)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1623_3977",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1623_3977",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1623_3977",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADQ0lEQVR4nO2dwWrUUBSGg0oLxY4rq9h240LfQcSNLnRj8TVa60IR30CXasGFiw4I0sGFggvrG9i6sHWjgoJCfQJp3dl+cjWDQ8ikY5J770n6fzBQ6G1y/vs1N5POSZokDQU4CzwEPgA/05f7+gFwJnZ9BwbgMHAP+MVw3PfuurGx6201wCHgGaPTcz8Tu+7WAtzh/7kdu+5WApwAdjKT7c4ZV4HJ9DUHfMyM2QamYtffOoBbOTI6OeOOAZ8yY28mbQcYBxaB9Zzf3BDMFdR2LUI9O+lcXAfGQsuYBt4Tl8mC+jqRa9t0cxTyyIgtY2uEOr9HrnEjyJEC3IgcdAu4PEKdV9KxMVkIIeStzwRJYHxmAdZCBHBvI72RBMZnFjdXTQ+A9wBty9P4AG3L0/gAbcvT+ABty+M7QNuQEGNIiDEkxBgSYgwJMYaEGENCjCEhxpAQY0iIMSTEGBJiDAkxhoQYQ0KMISHGkBBjSEh9vAROA7PA87IbkZB6+AJMDHxsfbLshiSkOrvAhUwfgYREZCmnscPdSFoKHSHV+Aoczcg4t88NpoVISHn2gEsZGRPA5wrbNC3klY+bWIAZYLVgvy/cPYbpa6Vg3KOcbd+nInXnzZuAssx4rGm2YL/HM7dVP8kZ8y1nqTqfnuAr4SvzYKFNEzKV8+CBp5ml6mLdS1UfX5kHiy3Lqg8p/JXxumC/K9mHB6RS3EMFHI99LFV96s6bNwFNZDlHypF04js+lqo+EjKc7n6P2ahzqeojIRWkVLkAHIaElJRS9QJwGBJSQoqPpaqPhIxOL72onEn/1O4FCTGGhBhDQowhIcaQEGNIiDEkxBgSYgwJMYaEGENC6kOdi4ZQ56IhdtW5aIulOj+40jmkGupcNMSeOhdrAHUulkadiz6osCSoc9GYEHUuGhMSk2V1Ltqjq85Fe3TVuWiPrjoX7dFV56I9eupcPIAkvokdsGlIiDEkxBgSYgwJMYaEGENCjCEhxpAQY0iIMSTEGBJiDAk5gEK8/vvulvEjhJD12CkbxJsQQhZjp2wQ8yGEjAObsZM2gHfAmHchqZRpYCN2YuMyTgWRMSBlDFhw66RO9H/YTudiPtiRIYQQQiT/+A25kFMcGkO61AAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyExamIcon);
export default __webpack_public_path__ + "static/media/MyExamIcon.ed787789f77e977be547d30ae529f16c.svg";
export { ForwardRef as ReactComponent };